import React from "react";
import ActionTop from "../../components/common/ActionTop";
import DiscoverItem from "../../components/common/DiscoverItem";
import useAuth from "../../Hooks/useAuth";

const Populars = () => {
  const {data} = useAuth()
  return (
    <>
      <section className="popular">
        <div className="container">
          <div className="popular-content">
            <h2 className="pageTitle">
              Popul<span>ar</span>
            </h2>
            <ActionTop />
            <div className="discover-items">
              {data.map((ele) => {
                return <DiscoverItem data={ele} key={ele.id} />;
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Populars;
